import AddLibCategory from "./AddLibCategory";

export default function SettingAdditions() {

    return (
        <div className="row row-cols-3 p-0">
            {/* <div className="d-flex flex-wrap jsutify-content-between gap-2 p-0"> */}
            <button className="col text-center position-relative btn-masar btn-light-beige text-white border border-1 border-white"
                data-bs-toggle="modal"
                data-bs-target="#addLibCategory">
                إضافة تصنيف كتاب
            </button>
            <AddLibCategory />
        </div>

    )
}

